module.exports = __webpack_public_path__ + "static/media/9.d5225b32.JPG";